import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "../services/common.service";
import { InquiryFormComponent } from "../shared/inquiry-form/inquiry-form.component";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { DATE_FORMATS } from "./../services/utils";

@Component({
  selector: "app-booking-inquiry",
  templateUrl: "./booking-inquiry.component.html",
  styleUrls: ["./booking-inquiry.component.scss"],
})
export class BookingInquiryComponent implements OnInit {
  @ViewChild(InquiryFormComponent) inquiryFormComponent: InquiryFormComponent;

  isLoading: boolean = false;
  isMobileView: boolean = false;
  isFlexfieldEnable: boolean = false;
  showVideoConf: boolean = false;
  isMemberVisible: boolean = false;
  isCategoryVisible: boolean = false;
  isEmailFieldRequired: boolean = false;
  isSubmitted: boolean = false;
  headerData = null;
  flexFieldData = null;
  bookingDetails: any = null;
  bookingFlexFieldDetails: any = null;
  dateFormats = DATE_FORMATS;

  constructor(
    private router: Router,
    private location: Location,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
    this.headerData = this.commonService.newAppointmentData.headerData;
    //set theme color here. Replace var with theme color.
    document.documentElement.style.setProperty("--custom-color", "#1b66dc");
    if (history.state.date) {
      let bookData = {
        category: history.state?.category,
        date: history.state?.date,
        member: history.state?.member,
        personnelLabel: history.state?.personnelLabel,
        time: history.state?.time,
        isCategoryVisible: history.state.isCategoryVisible,
        isMemberVisible: history.state.isMemberVisible,
      };
      sessionStorage.setItem("bookingDetails", JSON.stringify(bookData));
      this.isCategoryVisible = bookData.isCategoryVisible;
    }
    this.bookingDetails = JSON.parse(sessionStorage.getItem("bookingDetails"));
    this.isCategoryVisible = this.bookingDetails.isCategoryVisible;
    this.isMemberVisible = this.bookingDetails.isMemberVisible;
    if (!this.commonService.newAppointmentData.slug) {
      const localStorageSlug = sessionStorage.getItem("slug");
      this.commonService.newAppointmentData.slug = localStorageSlug;
      this.commonService.newAppointmentData.appointmentType = 2;
    }
    this.getMetaData();
  }

  public goBack() {
    this.location.back();
  }

  public goNext() {
    this.isSubmitted = true;
    if (!this.isValidData()) {
      return;
    }

    let inqData = this.inquiryFormComponent?.inquiryData;
    let flexData = this.inquiryFormComponent?.flexFieldData;

    let payloadData = {
      first_name: null,
      country_code: "91",
      phone_number: null,
      email_id: null,
      notes: null,
      meeting_link: null,
      slug: null,
      date: null,
      slot_time: null,
      tag_team_member: null,
      category_id: null,
      fields: null,
      source: "",
      is_option: null, // wapp option
    };
    payloadData.first_name = this.inquiryFormComponent.inquiryData.name;
    payloadData.phone_number =
      this.inquiryFormComponent.inquiryData.phoneNumber.toString();
    payloadData.email_id = this.inquiryFormComponent.inquiryData.email;
    payloadData.notes = this.inquiryFormComponent.inquiryData.description;
    if (this.showVideoConf) {
      payloadData.meeting_link =
        this.inquiryFormComponent.inquiryData?.videoConf;
    } else {
      payloadData.meeting_link = false;
    }
    payloadData.slug = this.commonService.newAppointmentData.slug;
    if (this.bookingDetails?.category) {
      payloadData.category_id = this.bookingDetails?.category?.category_id;
    }
    if (this.bookingDetails?.member) {
      payloadData.tag_team_member = this.bookingDetails?.member?.manager_id;
    }
    payloadData.date = moment(
      this.bookingDetails?.date,
      this.dateFormats.dateFirst
    ).format(this.dateFormats.yearFirst);
    payloadData.slot_time = this.bookingDetails?.time?.slot_time;
    payloadData.source = sessionStorage.getItem("source");

    if (this.isFlexfieldEnable) {
      let tmpFlexPayload = {};
      flexData?.forEach((element: any) => {
        if (element.input_type == "Toggle") {
          if (!element.value) {
            element.value = false;
          }
        }

        let tmpData = {
          flexId: element?.field_id,
          value: element?.value,
        };
        tmpFlexPayload[tmpData.flexId] = element.value;
      });
      payloadData.fields = tmpFlexPayload;
    }

    this.bookAppointment(payloadData);
  }

  private getMetaData() {
    this.isLoading = true;
    this.commonService.getAppointmentMetaData().subscribe((data: any) => {
      if (data.code === 200) {
        let res = data.data;
        let headerData = {
          outlet: res.business_outlet_name,
          business: res.business_name,
          business_logo: res.business_logo,
          is_welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.is_short_welcome_banner_text
            : res.appointment_setting_details.is_welcome_banner_text,
          welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.short_welcome_banner_text
            : res.appointment_setting_details.welcome_banner_text,
          outlet_address: res?.outlet_address,
          phone_number: res.appointment_setting_details?.phone_number,
        };
        this.commonService.newAppointmentData.headerData = headerData;
        this.headerData = headerData;
        headerData = null;

        //setting theme color set in the appointment settings
        const primaryColor =
          res.appointment_setting_details.primary_color_theme;
        sessionStorage.setItem("theme_color", primaryColor);
        this.commonService.newAppointmentData.themeColor = primaryColor;
        document.documentElement.style.setProperty(
          "--custom-color",
          primaryColor
        );

        if (
          res.appointment_setting_details.notification_channel?.toUpperCase() ==
          "EMAIL"
        ) {
          this.isEmailFieldRequired = true;
        } else {
          this.isEmailFieldRequired = false;
        }

        if (
          res.appointment_setting_details.tag_team_member &&
          !res.appointment_setting_details.auto_assign_team_member &&
          (res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
            "BOTH" ||
            res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
              "CONSUMER")
        ) {
          this.isMemberVisible = true;
        }

        this.isFlexfieldEnable =
          res.appointment_setting_details.enable_appointment_flex_field;

        this.flexFieldData = res.field_details;
        let tmpFlexData = [];
        this.flexFieldData.forEach((element: any) => {
          if (element.field_name) {
            if (element.input_type == "Toggle") {
              element.value = false;
            } else {
              element.value = null;
            }
            tmpFlexData.push(element);
          }
        });
        this.flexFieldData = [];
        this.flexFieldData = tmpFlexData;
        tmpFlexData = [];
        this.flexFieldData = JSON.parse(JSON.stringify(this.flexFieldData));

        const isGoogleConnected = res?.google == "connected" ? true : false;
        this.showVideoConf =
          isGoogleConnected &&
          res.appointment_setting_details?.enable_meeting_link;
        this.isLoading = false;
      }
    });
  }

  private bookAppointment(payload) {
    this.isLoading = true;
    this.commonService.bookAppointment(payload).subscribe(
      (data: any) => {
        if (data.code === 200) {
          this.isLoading = false;
          this.isSubmitted = false;
          let bookingId = data.data.appointment_id;
          sessionStorage.setItem("bookingId", bookingId);
          this.router.navigateByUrl("customer/booking-confirmation", {
            state: bookingId,
            replaceUrl: true,
          });
        }
      },
      (error: any) => {
        console.log("error", error.error);
        this.toastr.error(error.error.message);
        this.isLoading = false;
        this.isSubmitted = false;
      }
    );
  }

  public isValidData() {
    let basicData = this.inquiryFormComponent?.inquiryData;
    if (basicData?.name) {
      this.bookingDetails.name = basicData.name;
    } else {
      this.bookingDetails.name = "-";
    }
    if (basicData?.email) {
      this.bookingDetails.email = basicData.email;
    } else {
      this.bookingDetails.email = "-";
    }
    if (basicData?.phoneNumber) {
      this.bookingDetails.phone = basicData.phoneNumber;
    } else {
      this.bookingDetails.phone = "-";
    }
    if (basicData?.videoConf) {
      this.bookingDetails.isVideoConf = "Yes";
    } else {
      this.bookingDetails.isVideoConf = "No";
    }

    if (this.isFlexfieldEnable && this.inquiryFormComponent?.flexFieldData) {
      this.bookingFlexFieldDetails = this.inquiryFormComponent?.flexFieldData;
      let data = [];
      data = this.commonService.deepCloneArray(
        this.inquiryFormComponent.flexFieldData
      );
      data.forEach((element: any) => {
        if (element.input_type == "Toggle") {
          if (!element.value || element.value == "false") {
            element.value = "No";
          } else {
            element.value = "Yes";
          }
        } else {
          if (!element.value) {
            element.value = "-";
          }
        }
      });
      this.bookingFlexFieldDetails = null;
      this.bookingFlexFieldDetails = data;
    }

    // if Desktop then fetch data and show on RHS section.

    if (
      this.inquiryFormComponent?.isValidInquiryData() &&
      this.inquiryFormComponent?.isValidFlexData()
    ) {
      return true;
    } else {
      return false;
    }
  }
}
